import { render, staticRenderFns } from "./textContent-editor.vue?vue&type=template&id=4b3662be&scoped=true"
import script from "./textContent-editor.vue?vue&type=script&lang=js"
export * from "./textContent-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3662be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3662be')) {
      api.createRecord('4b3662be', component.options)
    } else {
      api.reload('4b3662be', component.options)
    }
    module.hot.accept("./textContent-editor.vue?vue&type=template&id=4b3662be&scoped=true", function () {
      api.rerender('4b3662be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-static-text/textContent-editor.vue"
export default component.exports